import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { TabsCardLayout } from '@icoach/components';
import MemberDetailCycleOrderContentOverview from '@icoach/memberDetail/MemberDetailCycleOrderContentOverview';
import CycleOrderContentBillingRecord from '@icoach/memberDetail/MemberDetailCycleOrderContentBillingRecord';
import { DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER } from '@icoach/router/routerPath';
import { isEqual, serialize } from '@util/utils';
import useTabState from '@util/hook/useTabState';
import { MEMBER_DETAIL_TABS_MAP } from '@icoach/memberDetail/staticData';

const MemberDetailCycleOrderContent = ({ className, memberID }) => {
    const { activeTab, handleTabChange } = useTabState(MEMBER_DETAIL_TABS_MAP.HC_OVERVIEW);
    const tabData = useMemo(
        () => {
            return [
                {
                    label: '循環訂單',
                    value: MEMBER_DETAIL_TABS_MAP.HC_OVERVIEW,
                },
                {
                    label: '收費明細',
                    value: MEMBER_DETAIL_TABS_MAP.HC_BILLING,
                },
            ];
        },
        // eslint-disable-next-line
        [],
    );

    const actionData = useMemo(
        () => {
            return [
                {
                    label: '新增訂購單',
                    variant: 'outlined',
                    component: NavLink,
                    to: `${DOCUMENT_HEALTHY_CYCLE_PURCHASE_ROUTER.CREATE}?${serialize({ memberID })}`,
                },
            ];
        },
        // eslint-disable-next-line
        [],
    );

    return (
        <TabsCardLayout
            className={className}
            activeTab={activeTab}
            tabs={tabData}
            actions={actionData}
            onTabChange={handleTabChange}
            tabsContent={{ className: 'pt-3 px-3 pb-3' }}
        >
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.HC_OVERVIEW) && <MemberDetailCycleOrderContentOverview memberID={memberID} />}
            {isEqual(activeTab, MEMBER_DETAIL_TABS_MAP.HC_BILLING) && <CycleOrderContentBillingRecord memberID={memberID} />}
        </TabsCardLayout>
    );
};

export default MemberDetailCycleOrderContent;
